import React, { useState, useEffect } from 'react';
import DataGrid, {
    Column,
    ColumnChooser,
    Paging,
    Scrolling,
    Export,
    Summary,
    GroupPanel,
    Grouping,
    GroupItem,
} from 'devextreme-react/data-grid';
import Request from "../../components/api/Request";
import { Button } from 'devextreme-react/button';
import 'devextreme/data/odata/store';
import CustomStore from 'devextreme/data/custom_store';
import DropDownBox from 'devextreme-react/drop-down-box';
import TreeView from 'devextreme-react/tree-view';
import { showToast, parseDate } from "../../utils/Utils";
import { ToastType } from "../../constants/Constants";
import './TesvikRaporBilgi.scss';

const TesvikRaporBilgi = () => {

    const listeBasligi = "Teşvik Rapor Bilgi";
    const [store, setStore] = useState(null);

    const [treeBoxValue, setTreeBoxValue] = useState([]);
    const [treeDataSource, setTreeDataSource] = useState([]);

    const [treeBoxDonemValue, setTreeBoxDonemValue] = useState([]);
    const [treeDataDonemSource, setTreeDataDonemSource] = useState([]);

    useEffect(() => {
        domainListYukle();
        donemListYukle();
        setStore(new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function () {
                return [];
            }
        }));
    }, []);

    const domainListYukle = () => {
        const request = new Request("/userDomain/getUserDomainList", "GET");
        request.run()
            .then(response => {
                if (response.data) {
                    setTreeDataSource(response.data.data);
                }
            });
    };

    const donemListYukle = () => {
        const request = new Request("/donem/getKayitList", "GET");
        request.run()
            .then(response => {
                if (response.data) {
                    response.data.data.map(d => {
                        d.tarih = parseDate(d.tarih);
                    });
                    let datas = [];
                    let simdi = new Date();
                    response.data.data.map(d => {
                        if (d.tarih.getTime() < simdi.getTime()) {
                            datas.push(d);
                        }
                    });
                    let yils = [];
                    let yilDatas = [];
                    datas.map(d => {
                        let parentYil = parseInt(d.donem.substring(0, 4)) * -1;
                        d.parentid = parentYil;
                        if (yils.indexOf(parentYil) === -1) {
                            yils.push(parentYil);
                            let donemTmp = (parentYil * -1).toString();
                            yilDatas.push({ donem: donemTmp, id: parentYil, parentid: 0 });
                        }
                    });
                    yilDatas.map(d => {
                        datas.push(d);
                    });
                    setTreeDataDonemSource(datas);
                }
            });
    };

    let dataGrid = null;
    let treeView = null;
    let treeViewDonem = null;

    const getStore = () => {
        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function () {
                let donemsTemp = [];
                treeBoxDonemValue.map(d => {
                    if (d > 0) {
                        donemsTemp.push(d);
                    }
                });

                const data = {
                    donems: donemsTemp,
                    domains: treeBoxValue,
                };

                const request = new Request("/tesvikRaporBilgiIslemleri/getKayitList", "POST", data);
                return request.run()
                    .then(response => {
                        if (response.data) {
                            let id = 1;
                            response.data.data.map(d => {
                                d.id = id;
                                id++;
                            });
                            return {
                                data: response.data.data,
                                totalCount: response.data.total,
                                summary: 0,
                                groupCount: 0
                            };
                        }
                        return [];
                    });
            }
        });
    };

    const yenile = () => {
        let domains = treeBoxValue;
        let donems = treeBoxDonemValue;

        let donemsTemp = [];
        donems.map(d => {
            if (d > 0) {
                donemsTemp.push(d);
            }
        });

        if (donems.length === 0) {
            showToast('Dönem Seçiniz', ToastType.ERROR, 500);
            return;
        }
        if (domains.length === 0) {
            showToast('Firma Seçiniz', ToastType.ERROR, 500);
            return;
        }
        if (donemsTemp.length > 48) {
            showToast('Hesaplanacak Dönem sayısı 48 ten fazla olamaz', ToastType.ERROR, 500);
            return;
        }

        setStore(getStore());
    };

    const syncTreeViewSelection = (e) => {
        let tree = (e.component.selectItem && e.component) || (treeView && treeView.instance);

        if (tree) {
            if (e.value === null) {
                tree.unselectAll();
            } else {
                let values = e.value || treeBoxValue;
                values && values.forEach(function (value) {
                    tree.selectItem(value);
                });
            }
        }

        if (e.value !== undefined) {
            if (e.value == null) {
                setTreeBoxValue([]);
            } else {
                setTreeBoxValue(e.value);
            }
        }
    };

    const treeView_itemSelectionChanged = (e) => {
        setTreeBoxValue(e.component.getSelectedNodeKeys());
    };

    const treeViewRender = () => {
        return (
            <TreeView dataSource={treeDataSource}
                ref={(ref) => treeView = ref}
                dataStructure="plain"
                keyExpr="id"
                parentIdExpr="parent.id"
                selectionMode="multiple"
                showCheckBoxesMode="normal"
                selectNodesRecursive={true}
                displayExpr="name"
                selectByClick={true}
                onContentReady={syncTreeViewSelection}
                onItemSelectionChanged={treeView_itemSelectionChanged}
                searchMode={'contains'}
                searchEnabled={true}
            />
        );
    };

    const syncTreeViewDonemSelection = (e) => {
        let tree = (e.component.selectItem && e.component) || (treeViewDonem && treeViewDonem.instance);

        if (tree) {
            if (e.value === null) {
                tree.unselectAll();
            } else {
                let values = e.value || treeBoxDonemValue;
                values && values.forEach(function (value) {
                    tree.selectItem(value);
                });
            }
        }

        if (e.value !== undefined) {
            if (e.value == null) {
                setTreeBoxDonemValue([]);
            } else {
                setTreeBoxDonemValue(e.value);
            }
        }
    };

    const treeViewDonem_itemSelectionChanged = (e) => {
        setTreeBoxDonemValue(e.component.getSelectedNodeKeys());
    };

    const treeViewDonemRender = () => {
        return (
            <TreeView dataSource={treeDataDonemSource}
                ref={(ref) => treeViewDonem = ref}
                dataStructure="plain"
                keyExpr="id"
                parentIdExpr="parentid"
                selectionMode="multiple"
                showCheckBoxesMode="normal"
                selectNodesRecursive={true}
                displayExpr="donem"
                selectByClick={true}
                onContentReady={syncTreeViewDonemSelection}
                onItemSelectionChanged={treeViewDonem_itemSelectionChanged}
            />
        );
    };

    function siraRender(data) {
        return (data.rowIndex + 1);
    }

    function onExporting(e) {
        let fileName = "";
        treeDataSource.map(sd => {
            if (treeBoxValue.indexOf(sd.id) > -1 && sd.sicilNo != null && sd.sicilNo !== "") {
                fileName += sd.name;
            }
        });

        if (fileName === "") {
            fileName = "TesvikRaporBilgi";
        }
        e.fileName = fileName.substring(0, 100);
    }

    return (
        <div>
            <h2 className={'dx-icon-product'}>{listeBasligi}</h2>
            <div className="dx-field">
                <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>
                    <DropDownBox
                        value={treeBoxValue}
                        valueExpr="id"
                        displayExpr="name"
                        placeholder="Firma Seçiniz..."
                        showClearButton={true}
                        dataSource={treeDataSource}
                        onValueChanged={syncTreeViewSelection}
                        contentRender={treeViewRender}
                        width="500"
                    />
                    <DropDownBox
                        value={treeBoxDonemValue}
                        valueExpr="id"
                        displayExpr="donem"
                        placeholder="Dönem Seçiniz..."
                        showClearButton={true}
                        dataSource={treeDataDonemSource}
                        onValueChanged={syncTreeViewDonemSelection}
                        contentRender={treeViewDonemRender}
                        width="500"
                    />
                    <Button icon="plus" width={150} text="Yenile" type={'success'} style={{ fontSize: "15px" }}
                        onClick={yenile} />
                </div>
            </div>

            <DataGrid
                className="tesvikRaporBilgiListesiGrid"
                ref={ref => dataGrid = ref}
                width="100%"
                dataSource={store}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                columnAutoWidth={false}
                selection={{ mode: 'single', deferred: true }}
                onExporting={onExporting}
            >
                <Export enabled={true} />
                <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={true} />
                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />
                <Paging enabled={false} />

                <Column width={30} caption={'Sıra'} dataType="number" visible={true} cellRender={siraRender} />
                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} />
                <Column dataField={'domainId'} width={90} caption={'Domain Id'} dataType="number" visible={false} />
                <Column dataField={'donemId'} width={90} caption={'Dönem Id'} dataType="number" visible={false} />
                <Column dataField={'domainName'} width={200} caption={'Firma'} dataType="string" visible={true} groupIndex={0} />
                <Column dataField={'donemName'} width={120} caption={'Dönem'} dataType="string" visible={true} />
                <Column dataField={'kanunNo'} width={100} caption={'Kanun No'} dataType="number" visible={true} />
                <Column dataField={'pirimDestegiTutarPrint'} width={180} caption={'Prim Desteği Tutar'} dataType="number" visible={true} />
                <Column dataField={'hazineIndirimiTutarPrint'} width={150} caption={'Hazine İndirmi'} dataType="number" visible={true} />
                <Column dataField={'personelSayisi'} width={120} caption={'Personel Sayısı'} dataType="number" visible={true} />
                <Column dataField={'toplamPek'} width={120} caption={'Toplam (PEK)'} dataType="number" visible={true} />
                <Column dataField={'pirimDestegiTutarYude5Dahil'} width={150} caption={'Prim Desteği Tutar (%5 dahil)'} dataType="number" visible={true} />
                <Column dataField={''} width={120} caption={''} dataType="number" visible={true} />



                <Column dataField={'primDestegiTutarYude5'} width={150} caption={'Prim Desteği Tutar %5 '} dataType="number" visible={false} />
                <Column dataField={'pirimDestegiTutarYude5Haric'} width={150} caption={'Prim Desteği Tutar (%5 hariç)'} dataType="number" visible={false} />
                <Column dataField={'pirimDestegiTutar'} width={150} caption={'Prim Desteği Tutar'} dataType="number" visible={false} />
                <Column dataField={'vergiTutari'} width={150} caption={'Vergi Tutarı'} dataType="number" visible={false} />
                <Column dataField={'tesvikTutar'} width={150} caption={'Teşvik Tutar'} dataType="number" visible={false} />

                <Summary>
                    <GroupItem
                        column="pirimDestegiTutarPrint"
                        summaryType="sum"
                        valueFormat="decimal"
                        showInGroupFooter={true}
                        alignByColumn={true}
                        displayFormat="Toplam: {0} TL" />
                    <GroupItem
                        column="hazineIndirimiTutarPrint"
                        summaryType="sum"
                        valueFormat="decimal"
                        showInGroupFooter={true}
                        alignByColumn={true}
                        displayFormat="Toplam: {0} TL" />
                </Summary>
            </DataGrid>
        </div>
    );
};

export default TesvikRaporBilgi;
